// Public UI adapted from Klargo-Reference/components/landing/ServiceLogoRow.tsx.
import bankidLogo from '../../assets/partners/bankid-logo.png';
import bilvisionLogo from '../../assets/partners/bilvision-logo.svg';
import swishLogo from '../../assets/partners/swish-logo.png';
import zmartaLogo from '../../assets/partners/zmarta-logo.svg';
import { useDsBreakpoints } from '../ds/useDsBreakpoints.jsx';
const TARGET = 30;
const TARGET_MOBILE = 26;
const SERVICES = [
    { name: 'Swish', url: swishLogo, ratio: 1424 / 1920, optical: 1 },
    { name: 'BankID', url: bankidLogo, ratio: 317 / 300, optical: 1 },
    { name: 'Bilvision', url: bilvisionLogo, ratio: 184.2 / 21.6, optical: 1 },
    { name: 'Zmarta', url: zmartaLogo, ratio: 92.9 / 18.25, optical: 0.87 },
];
const ServiceLogoRow = ({ label }) => {
    const { isMobile } = useDsBreakpoints();
    const target = isMobile ? TARGET_MOBILE : TARGET;
    const maxHeight = target / Math.sqrt(Math.min(...SERVICES.map((s) => s.ratio)));
    return (<div className="mt-7">
      <div className="mb-3 text-[11.5px] font-medium tracking-[0.02em] text-ds-muted">{label}</div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
      {SERVICES.map((service) => {
            const height = (target / Math.sqrt(service.ratio)) * service.optical;
            return (<span key={service.name} className="inline-flex items-center justify-center" style={{ height: maxHeight }}>
            <img src={service.url} alt={service.name} loading="lazy" className="w-auto object-contain opacity-90" style={{ height }}/>
          </span>);
        })}
      </div>
    </div>);
};
export default ServiceLogoRow;
